import { Dialog, DialogProps } from "../../core/components/dialog.js";
import { Helper } from "../../core/util/helper.js";
import { Config } from "../../core/config/config.js";
import ContainerFilterDropDown from "../../favoriteFilter/containerFilterDropDown.js";
import React from "react";
import ReactDOM from "react-dom";

export const OpenContainerFilterDialog = (initialId: number = null) => {
    return new Promise<number>((resolve, reject) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);
        root.render(
            <>
                <React.StrictMode>
                    <ContainerFilter
                        initialId={initialId}
                        onError={reject}
                        onClose={resolve}
                    />
                </React.StrictMode>
            </>
        );
    })
}

interface ContainerFilterProps {
    initialId: number;
    onError: () => void;
    onClose: (id: number) => void;
}

export default class ContainerFilter extends React.Component<ContainerFilterProps, ContainerFilterState>{
    private dialogProps: DialogProps = {
        title: "",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onClose(this.props.initialId)
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onClose(this.state.selected)
                },
                primary: true
            }
        ],
        width: 500
    };
    private readonly afterDialogClose: any;
    private readonly beforeDialogOpen: any;

    constructor(props: ContainerFilterProps) {
        super(props)
        this.state = {
            selected: this.props.initialId,
            open: true
        };
        this.afterDialogClose = this.handlerGenerator(true)
        this.beforeDialogOpen = this.handlerGenerator(false);
    }

    private handlerGenerator = (dialogOpen: boolean) => {
        return () => {
            return new Promise<void>((resolve) => {
                this.setState({open: dialogOpen}, resolve)
            })
        };
    }

    componentDidCatch(error: any, _: any) {
        console.error(error)
        this.setState({ open: false }, this.props.onError);
    }

    render() {
        return (
            <>
                <Dialog {...this.dialogProps} open={this.state.open} title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.SelectFilter")}>
                    <ContainerFilterDropDown
                        field={null}
                        onChange={(_, id) => { this.setState({ selected: id }) }}
                        value={this.state.selected}
                        afterDialogClose={this.afterDialogClose}
                        beforeDialogOpen={this.beforeDialogOpen}
                        onError={this.componentDidCatch}
                    />
                </Dialog>
            </>
        );
    }
}

interface ContainerFilterState {
    selected: number;
    open: boolean;
}